var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2726 39.1426H2.72718C2.23459 39.1426 1.75719 38.9379 1.40145 38.5652C1.04495 38.1917 0.84082 37.6804 0.84082 37.1426V2.85693C0.84082 2.31919 1.04495 1.80788 1.40145 1.4344C1.75719 1.06172 2.23459 0.856934 2.72718 0.856934H27.2726C27.7652 0.856934 28.2426 1.06172 28.5984 1.4344C28.9549 1.80788 29.159 2.31919 29.159 2.85693V37.1426C29.159 37.6804 28.9549 38.1917 28.5984 38.5652C28.2426 38.9379 27.7652 39.1426 27.2726 39.1426Z",
    fill: "white",
    stroke: "#717070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72727 0.714286C2.18478 0.714286 1.66452 0.94005 1.28092 1.34191C0.897321 1.74378 0.681818 2.28882 0.681818 2.85714V37.1429C0.681818 37.7112 0.897321 38.2562 1.28092 38.6581C1.66452 39.0599 2.18478 39.2857 2.72727 39.2857H27.2727C27.8152 39.2857 28.3355 39.0599 28.7191 38.6581C29.1027 38.2562 29.3182 37.7112 29.3182 37.1429V2.85714C29.3182 2.28882 29.1027 1.74378 28.7191 1.34191C28.3355 0.94005 27.8152 0.714286 27.2727 0.714286H2.72727ZM2.72727 0H27.2727C27.996 0 28.6897 0.30102 29.2012 0.836838C29.7127 1.37266 30 2.09938 30 2.85714V37.1429C30 37.9006 29.7127 38.6273 29.2012 39.1632C28.6897 39.699 27.996 40 27.2727 40H2.72727C2.00396 40 1.31026 39.699 0.7988 39.1632C0.287337 38.6273 0 37.9006 0 37.1429V2.85714C0 2.09938 0.287337 1.37266 0.7988 0.836838C1.31026 0.30102 2.00396 0 2.72727 0V0Z",
    fill: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86523 28.085L25.9463 28.085",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05371 34.0425H25.9456",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 14C24.125 19.0396 20.0396 23.125 15 23.125C9.9604 23.125 5.875 19.0396 5.875 14C5.875 8.9604 9.9604 4.875 15 4.875C20.0396 4.875 24.125 8.9604 24.125 14Z",
    stroke: "#717070",
    strokeWidth: 1.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 18.8147L19.8147 9.92578",
    stroke: "#717070",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8147 18.8147L10.9258 9.92578",
    stroke: "#717070",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.e80e78d66e39d72a5d446e0271ea0eb3.svg";
export { ForwardRef as ReactComponent };